import React from 'react'
import './App.css';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import DatasetsPage from './pages/datasetsPage';
import LabelsPage from './pages/labelsPage';
import LandingPage from './pages/landingPage';
import ProjectsPage from './pages/projectsPage';

function App() {
  return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="label" element={<LabelsPage />} />
          <Route path="datasets" element={<DatasetsPage />} />
          <Route path="projects" element={<ProjectsPage />} />
        </Routes>
      </BrowserRouter>
  );
}

export default App;
